<template>
  <div>
    <button
      class="ma-btn ma-btn-ghost ma-btn-sm"
      style="margin-bottom:18px;"
      @click="$router.push({ name: 'minds-admin-groups' })"
    >
      <feather-icon
        icon="ArrowLeftIcon"
        size="15"
      /> Retour aux groupes
    </button>

    <div
      v-if="loading"
      class="ma-loading"
    >
      Chargement…
    </div>

    <template v-else-if="group">
      <!-- Hero -->
      <div
        class="ma-group-hero"
        :style="{ background: `linear-gradient(135deg, ${group.color || '#14B8A6'}, #0E9384)` }"
      >
        <div class="ma-group-hero-main">
          <h1>{{ group.name }}</h1>
          <div class="ma-group-hero-tags">
            <span
              v-if="group.level"
              class="ma-hero-badge"
            >{{ group.level }}</span>
            <span
              v-if="group.subject"
              class="ma-hero-badge"
            >{{ group.subject }}</span>
            <span class="ma-hero-badge code">Code : {{ group.code }}</span>
          </div>
          <p class="ma-group-hero-tutor">
            <feather-icon
              icon="UserCheckIcon"
              size="16"
            />
            {{ group.tutor ? group.tutor.fullName : 'Aucun tuteur affecté' }}
          </p>
        </div>
        <div class="ma-group-hero-actions">
          <button
            class="ma-hero-btn"
            @click="openEdit"
          >
            <feather-icon
              icon="Edit2Icon"
              size="15"
            /> Modifier
          </button>
          <button
            class="ma-hero-btn danger"
            @click="showDelete = true"
          >
            <feather-icon
              icon="Trash2Icon"
              size="15"
            /> Supprimer
          </button>
        </div>
      </div>

      <!-- Membres -->
      <div
        class="ma-card"
        style="margin-top:22px;"
      >
        <div class="ma-members-head">
          <div>
            <h3 style="font-weight:800;margin:0;">
              Étudiants du groupe
            </h3>
            <p class="ma-page-sub" style="margin:2px 0 0;">
              {{ (group.students || []).length }} membre(s)
            </p>
          </div>
          <button
            class="ma-btn ma-btn-primary"
            @click="openAdd"
          >
            <feather-icon
              icon="UserPlusIcon"
              size="16"
            /> Ajouter des étudiants
          </button>
        </div>

        <div
          v-if="!(group.students || []).length"
          class="ma-empty"
        >
          <div class="ma-empty-ico">
            <feather-icon
              icon="UsersIcon"
              size="28"
            />
          </div>
          <h4>Aucun étudiant</h4>
          <p>Ajoute des étudiants depuis la base pour composer ce groupe.</p>
        </div>
        <table
          v-else
          class="ma-table"
        >
          <thead>
            <tr>
              <th>Étudiant</th>
              <th>Niveau</th>
              <th class="text-right">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="s in group.students"
              :key="s._id"
            >
              <td>
                <div class="ma-identity">
                  <div class="ma-avatar">
                    {{ initials(s.fullName) }}
                  </div>
                  <div>
                    <div class="ma-identity-name">
                      {{ s.fullName }}
                    </div>
                    <div class="ma-identity-mail">
                      {{ s.email }}
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <span
                  v-if="s.level"
                  class="ma-badge level"
                >{{ s.level }}</span>
                <span
                  v-else
                  style="color:var(--ma-muted);"
                >—</span>
              </td>
              <td class="text-right">
                <button
                  class="ma-btn ma-btn-danger ma-btn-sm"
                  @click="removeMember(s)"
                >
                  <feather-icon
                    icon="UserMinusIcon"
                    size="14"
                  /> Retirer
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <!-- Modal ajout membres -->
    <div
      v-if="showAdd"
      class="ma-modal-backdrop"
      @click.self="showAdd = false"
    >
      <div class="ma-modal lg">
        <div class="ma-modal-head">
          <h3 class="ma-modal-title">
            Ajouter des étudiants
          </h3>
          <p class="ma-modal-sub">
            Sélectionne les étudiants à ajouter au groupe {{ group.level }}.
          </p>
        </div>
        <div class="ma-modal-body">
          <div class="ma-toolbar" style="margin-bottom:12px;">
            <div class="ma-search">
              <feather-icon
                icon="SearchIcon"
                size="16"
              />
              <input
                v-model="dirSearch"
                type="text"
                placeholder="Rechercher…"
              >
            </div>
            <label
              v-if="group.level"
              style="display:inline-flex;align-items:center;gap:8px;font-weight:600;font-size:0.84rem;cursor:pointer;"
            >
              <input
                v-model="dirSameLevel"
                type="checkbox"
                style="accent-color:#14B8A6;"
              >
              Niveau {{ group.level }} uniquement
            </label>
          </div>

          <div class="ma-dir-list">
            <div
              v-for="s in candidates"
              :key="s._id"
              class="ma-dir-row"
              @click="toggle(s._id)"
            >
              <input
                type="checkbox"
                :checked="selected.includes(s._id)"
                style="accent-color:#14B8A6;width:16px;height:16px;"
                @click.stop="toggle(s._id)"
              >
              <div class="ma-identity" style="flex:1;">
                <div class="ma-avatar">
                  {{ initials(s.fullName) }}
                </div>
                <div>
                  <div class="ma-identity-name">
                    {{ s.fullName }}
                  </div>
                  <div class="ma-identity-mail">
                    {{ s.email }}
                  </div>
                </div>
              </div>
              <span
                v-if="s.level"
                class="ma-badge level"
              >{{ s.level }}</span>
            </div>
            <div
              v-if="!candidates.length"
              class="ma-empty"
              style="padding:30px;"
            >
              {{ directory.length ? 'Aucun étudiant disponible avec ces filtres.' : 'Aucun étudiant en base.' }}
            </div>
          </div>
        </div>
        <div class="ma-modal-foot">
          <span style="margin-right:auto;color:var(--ma-muted);font-weight:600;font-size:0.85rem;">{{ selected.length }} sélectionné(s)</span>
          <button
            class="ma-btn ma-btn-ghost"
            @click="showAdd = false"
          >
            Fermer
          </button>
          <button
            class="ma-btn ma-btn-primary"
            :disabled="adding || !selected.length"
            @click="addMembers"
          >
            <span
              v-if="adding"
              class="ma-loader"
            />
            <span v-else>Ajouter au groupe</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Modal édition -->
    <div
      v-if="showEdit"
      class="ma-modal-backdrop"
      @click.self="showEdit = false"
    >
      <div class="ma-modal">
        <div class="ma-modal-head">
          <h3 class="ma-modal-title">
            Modifier le groupe
          </h3>
        </div>
        <div class="ma-modal-body">
          <div class="ma-field">
            <label>Nom</label>
            <input
              v-model="editForm.name"
              class="ma-input"
              type="text"
            >
          </div>
          <div class="ma-row">
            <div class="ma-field">
              <label>Niveau</label>
              <select
                v-model="editForm.level"
                class="ma-input"
              >
                <option value="">
                  —
                </option>
                <option
                  v-for="l in levels"
                  :key="l"
                  :value="l"
                >
                  {{ l }}
                </option>
              </select>
            </div>
            <div class="ma-field">
              <label>Matière</label>
              <select
                v-model="editForm.subject"
                class="ma-input"
              >
                <option value="">
                  —
                </option>
                <option
                  v-for="s in subjects"
                  :key="s"
                  :value="s"
                >
                  {{ s }}
                </option>
              </select>
            </div>
          </div>
          <div class="ma-field">
            <label>Tuteur</label>
            <select
              v-model="editForm.tutor"
              class="ma-input"
            >
              <option value="">
                — Aucun —
              </option>
              <option
                v-for="t in tutors"
                :key="t._id"
                :value="t._id"
              >
                {{ t.fullName }}
              </option>
            </select>
          </div>
        </div>
        <div class="ma-modal-foot">
          <button
            class="ma-btn ma-btn-ghost"
            @click="showEdit = false"
          >
            Annuler
          </button>
          <button
            class="ma-btn ma-btn-primary"
            :disabled="savingEdit"
            @click="saveEdit"
          >
            <span
              v-if="savingEdit"
              class="ma-loader"
            />
            <span v-else>Enregistrer</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Modal suppression -->
    <div
      v-if="showDelete"
      class="ma-modal-backdrop"
      @click.self="showDelete = false"
    >
      <div
        class="ma-modal"
        style="max-width:420px;"
      >
        <div class="ma-modal-head">
          <h3 class="ma-modal-title">
            Supprimer ce groupe ?
          </h3>
          <p class="ma-modal-sub">
            <strong>{{ group && group.name }}</strong> sera supprimé. Les comptes étudiants ne sont pas supprimés.
          </p>
        </div>
        <div class="ma-modal-foot">
          <button
            class="ma-btn ma-btn-ghost"
            @click="showDelete = false"
          >
            Annuler
          </button>
          <button
            class="ma-btn ma-btn-danger"
            :disabled="deleting"
            @click="doDelete"
          >
            <span v-if="deleting">…</span>
            <span v-else>Supprimer</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import axios from '@axios'
import { LEVELS, SUBJECTS } from './constants'

export default {
  name: 'MindsAdminGroupView',
  data() {
    return {
      loading: true,
      group: null,
      tutors: [],
      levels: LEVELS,
      subjects: SUBJECTS,
      // ajout membres
      showAdd: false,
      directory: [],
      dirSearch: '',
      dirSameLevel: true,
      selected: [],
      adding: false,
      // édition
      showEdit: false,
      editForm: {
        name: '', level: '', subject: '', tutor: '',
      },
      savingEdit: false,
      // suppression
      showDelete: false,
      deleting: false,
    }
  },
  computed: {
    id() { return this.$route.params.id },
    candidates() {
      const memberIds = new Set((this.group.students || []).map(s => String(s._id)))
      const q = this.dirSearch.trim().toLowerCase()
      const level = this.group.level
      return this.directory.filter(s => !memberIds.has(String(s._id))
        && (!this.dirSameLevel || !level || s.level === level)
        && (!q || (s.fullName || '').toLowerCase().includes(q) || (s.email || '').toLowerCase().includes(q)))
    },
  },
  mounted() {
    this.fetch()
    this.fetchTutors()
  },
  methods: {
    initials(name) {
      const n = (name || '?').trim().split(/\s+/)
      return ((n[0] || '')[0] || '?').toUpperCase() + ((n[1] || '')[0] || '').toUpperCase()
    },
    async fetch() {
      this.loading = true
      try {
        const res = await axios.get(`/ma/admin/groups/${this.id}`)
        this.group = res.data.group
      } catch (e) {
        this.group = null
      } finally {
        this.loading = false
      }
    },
    async fetchTutors() {
      try {
        const res = await axios.get('/ma/admin/users', { params: { role: 'tutor' } })
        this.tutors = res.data.users || []
      } catch (e) {
        this.tutors = []
      }
    },
    async openAdd() {
      this.selected = []
      this.dirSearch = ''
      this.dirSameLevel = true
      this.showAdd = true
      try {
        const res = await axios.get('/ma/admin/users', { params: { role: 'student' } })
        this.directory = res.data.users || []
      } catch (e) {
        this.directory = []
      }
    },
    toggle(id) {
      const i = this.selected.indexOf(id)
      if (i >= 0) this.selected.splice(i, 1)
      else this.selected.push(id)
    },
    async addMembers() {
      if (!this.selected.length || this.adding) return
      this.adding = true
      try {
        const res = await axios.post(`/ma/admin/groups/${this.id}/members`, { userIds: this.selected })
        this.group = res.data.group
        this.showAdd = false
      } catch (e) {
        // noop
      } finally {
        this.adding = false
      }
    },
    async removeMember(s) {
      try {
        const res = await axios.delete(`/ma/admin/groups/${this.id}/members/${s._id}`)
        this.group = res.data.group
      } catch (e) {
        // noop
      }
    },
    openEdit() {
      this.editForm = {
        name: this.group.name || '',
        level: this.group.level || '',
        subject: this.group.subject || '',
        tutor: this.group.tutor ? this.group.tutor._id : '',
      }
      this.showEdit = true
      if (!this.tutors.length) this.fetchTutors()
    },
    async saveEdit() {
      if (this.savingEdit) return
      this.savingEdit = true
      try {
        const res = await axios.patch(`/ma/admin/groups/${this.id}`, this.editForm)
        this.group = res.data.group
        this.showEdit = false
      } catch (e) {
        // noop
      } finally {
        this.savingEdit = false
      }
    },
    async doDelete() {
      if (this.deleting) return
      this.deleting = true
      try {
        await axios.delete(`/ma/admin/groups/${this.id}`)
        this.$router.push({ name: 'minds-admin-groups' })
      } catch (e) {
        this.deleting = false
      }
    },
  },
}
</script>

<style src="./minds.css"></style>
<style scoped>
.ma-group-hero { border-radius: 22px; padding: 30px 32px; color: #fff; display: flex; justify-content: space-between; align-items: flex-start; gap: 20px; flex-wrap: wrap; box-shadow: var(--ma-shadow); }
.ma-group-hero-main h1 { font-size: 1.9rem; font-weight: 800; margin: 0 0 12px; }
.ma-group-hero-tags { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 14px; }
.ma-hero-badge { background: rgba(255,255,255,0.22); padding: 5px 14px; border-radius: 20px; font-weight: 700; font-size: 0.8rem; backdrop-filter: blur(4px); }
.ma-hero-badge.code { background: rgba(255,255,255,0.32); }
.ma-group-hero-tutor { display: flex; align-items: center; gap: 8px; font-weight: 600; margin: 0; opacity: 0.95; }
.ma-group-hero-actions { display: flex; gap: 10px; }
.ma-hero-btn { display: inline-flex; align-items: center; gap: 7px; background: rgba(255,255,255,0.2); color: #fff; border: none; padding: 9px 15px; border-radius: 11px; font-weight: 700; font-size: 0.85rem; cursor: pointer; backdrop-filter: blur(4px); transition: background 0.14s ease; }
.ma-hero-btn:hover { background: rgba(255,255,255,0.32); }
.ma-hero-btn.danger:hover { background: #FF6F59; }
.ma-members-head { display: flex; justify-content: space-between; align-items: center; gap: 14px; padding: 22px 22px 16px; flex-wrap: wrap; }
.ma-dir-list { max-height: 340px; overflow-y: auto; border: 1px solid var(--ma-line); border-radius: 12px; }
.ma-dir-row { display: flex; align-items: center; gap: 12px; padding: 10px 14px; border-bottom: 1px solid #F1F5F9; cursor: pointer; }
.ma-dir-row:last-child { border-bottom: none; }
.ma-dir-row:hover { background: #F8FAFC; }
</style>
